import { AlertLine, AlertLineSlide } from '@direct-frontend/components';
import { useExperimentFlag } from '#shared/lib/flags';
import { checkIsYCP } from '#shared/lib/ycp';
import styles from './YcpServiceAlert.module.css';

export function YcpServiceAlert() {
    const isAlertHidden = useExperimentFlag('enable_ycp_publish_btn_and_hide_alert');

    if (!checkIsYCP() || isAlertHidden) {
        return null;
    }

    return (
        <AlertLine className={styles.root}>
            <AlertLineSlide
                color="warning"
                title="Кабинет может работать нестабильно. Отображение кнопки «Купить» в Поиске и Алисе AI и публикация чекаутов временно невозможны. Информация о заказах может отображаться с задержкой. Делаем всё возможное, чтобы восстановить функциональность. Сообщим, когда можно будет завершить интеграцию."
            />
        </AlertLine>
    );
}
